import { fromJS, Map, List } from 'immutable';
import { ERROR, START, SUCCESS } from '../../consts';
import { TARIFFS_LOAD } from './actionTypes';


export const DEFAULT_STATE = fromJS({
  loading: 0,
  loaded: false,
  tariffs: new List(),
});

export default function tariffs (state = DEFAULT_STATE, action) {
  switch (action.type) {
    // загрузка тарифов
    case TARIFFS_LOAD + START:
      return state.merge({
        loading: state.get('loading') + 1,
        error: null
      });
    case TARIFFS_LOAD + SUCCESS:
      return state.merge({
        loading: state.get('loading') - 1,
        loaded: true,
        tariffs: action.items,
      });
    case TARIFFS_LOAD + ERROR:
      return state.merge({
        loading: state.get('loading') - 1,
        loaded: false,
        tariffs: new List(),
        error: action.payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Tariffs/reducer.js